import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'

type NewApplicationFormState = {
	isFormValid: boolean
	formValues: Record<string, any>
	currentStep: number
}

type NewApplicationFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		setFormValidity: (isValid: boolean) => void
		setCurrentStep: (step: number) => void
	}
}

const initialFormValues = {
	gcpProjectID: '',
	deployment: '',
	dataClassification: '',
	tierLevel: '',
	portfolio: '',
	applicationName: '',
	applicationAlias: '',
	environment: '',
	infrastructureType: '',
	platformName: '',
	platformAlias: '',
	applicationViewer: [],
	platformOwner: '',
	platformOwnerEmail: '',
	applicationOwner: '',
	applicationOwnerEmail: '',
	wbsCode: '',
	costCenter: '',
	creationTime: '',
	sourceEnvName: '',
	additionalEnvName: '',
	sitEnvironmentName: {
		label: '',
		value: ''
	},
	isInheritTagsChecked: false,
	isInheritProjectTags: false,
	isEphemeralActive: false,
	isSubmitBlocked: false,
	isSitEnvironmentChecked: false
}

const newApplicationFromStore = create<
	NewApplicationFormState & NewApplicationFormActions
>((set, _get) => ({
	currentStep: 0,
	isFormValid: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () =>
			set(() => ({
				formValues: initialFormValues,
				isFormValid: false
			})),

		setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),

		setFormValues: (fieldName, value) =>
			set((state) =>
				produce(state, (draft) => {
					if (fieldName === 'applicationViewer') {
						const emails = Array.isArray(value)
							? value.map((email: string) => String(email ?? '').trim())
							: String(value ?? '')
									.split(',')
									.map((email: string) => email.trim())
						draft.formValues[fieldName] = emails
					} else {
						draft.formValues[fieldName] = value
					}
				})
			),

		setCurrentStep: (step) => {
			set(() => ({
				currentStep: step
			}))
		}
	}
}))

export const useNewApplicationFormStore = () =>
	newApplicationFromStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool('NewApplicationFormStore', newApplicationFromStore)
}
